import React from 'react';

export default function StatCard({ title, value, subtitle, icon: Icon, color = 'primary' }) {
  const colors = {
    primary: 'bg-primary',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger',
    secondary: 'bg-secondary',
  };

  return (
    <div className="bg-white rounded-xl shadow p-6 flex items-center gap-4">
      {Icon && (
        <div className={`${colors[color]} text-white p-3 rounded-lg flex-shrink-0`}>
          <Icon size={24} />
        </div>
      )}
      <div className="min-w-0 flex-1 overflow-hidden">
        <p className="text-sm text-gray-500 whitespace-normal break-words">{title}</p>
        <p className="text-2xl font-bold text-gray-800 whitespace-nowrap overflow-hidden text-overflow-clip">{value}</p>
        {subtitle && <p className="text-xs text-gray-400 mt-1 truncate">{subtitle}</p>}
      </div>
    </div>
  );
}
